import { render, staticRenderFns } from "./ImportManage.vue?vue&type=template&id=04d20880&scoped=true"
import script from "./ImportManage.vue?vue&type=script&lang=js"
export * from "./ImportManage.vue?vue&type=script&lang=js"
import style0 from "./ImportManage.vue?vue&type=style&index=0&id=04d20880&prod&lang=scss&scoped=true"
import style1 from "./ImportManage.vue?vue&type=style&index=1&id=04d20880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d20880",
  null
  
)

export default component.exports